import clsx from 'clsx'
import { type FC } from 'react'
import { type BackgroundType } from '../types'
import { VideoCallIcon } from './videoCallIcons'

type VirtualBackgroundMenuProps = {
  backgroundType: BackgroundType
  selectedBackgroundUrl: string | null
  onApplyBackground: (type: BackgroundType, imageUrl?: string) => void
  onOpenGallery: () => void
}

export const VirtualBackgroundMenu: FC<VirtualBackgroundMenuProps> = ({
  backgroundType,
  selectedBackgroundUrl,
  onApplyBackground,
  onOpenGallery,
}) => (
  <div
    className='position-absolute z-index-3 bg-body rounded shadow py-2'
    style={{ top: 74, right: 24, minWidth: 200 }}
  >
    <button
      onClick={() => onApplyBackground('none')}
      className={clsx(
        'btn btn-flush btn-active-light d-flex align-items-center gap-3 w-100 border-0 text-start fs-7 px-4 py-3 rounded-0',
        backgroundType === 'none' && 'active bg-light'
      )}
      type='button'
    >
      <i className={`${VideoCallIcon.Remove} w-20px`} />
      <span>Nenhum</span>
      {backgroundType === 'none' && <i className={`${VideoCallIcon.Check} ms-auto text-primary`} />}
    </button>

    <button
      onClick={() => onApplyBackground('blur')}
      className={clsx(
        'btn btn-flush btn-active-light d-flex align-items-center gap-3 w-100 border-0 text-start fs-7 px-4 py-3 rounded-0',
        backgroundType === 'blur' && 'active bg-light'
      )}
      type='button'
    >
      <i className={`${VideoCallIcon.Blur} w-20px`} />
      <span>Desfocar fundo</span>
      {backgroundType === 'blur' && <i className={`${VideoCallIcon.Check} ms-auto text-primary`} />}
    </button>

    <button
      onClick={() => onApplyBackground('image')}
      className={clsx(
        'btn btn-flush btn-active-light d-flex align-items-center gap-3 w-100 border-0 text-start fs-7 px-4 py-3 rounded-0',
        backgroundType === 'image' && !selectedBackgroundUrl && 'active bg-light'
      )}
      type='button'
    >
      <i className={`${VideoCallIcon.Paint} w-20px`} />
      <span>Gradiente padrão</span>
      {backgroundType === 'image' && !selectedBackgroundUrl && (
        <i className={`${VideoCallIcon.Check} ms-auto text-primary`} />
      )}
    </button>

    <div className='separator my-2' />

    <button
      onClick={onOpenGallery}
      className='btn btn-flush btn-active-light d-flex align-items-center gap-3 w-100 border-0 text-start fs-7 px-4 py-3 fw-semibold text-primary rounded-0'
      type='button'
    >
      <i className={`${VideoCallIcon.Add} w-20px`} />
      <span>Gerenciar fundos...</span>
    </button>
  </div>
)
